import { useBusinessProfileSetupMocks } from '../../../shared/env';
import { httpBusinessProfileSetupGateway } from './HttpBusinessProfileSetupGateway';
import { mockBusinessProfileSetupGateway, type MockBusinessProfileSetupGatewayHooks } from './MockBusinessProfileSetupGateway';
import type { IBusinessProfileSetupGateway } from './IBusinessProfileSetupGateway';

/** Selected once at module load, exactly like identityGateway/dashboardGateway/companiesGateway — every
 * step component imports this single instance, never either implementation directly. Real HTTP calls are
 * made whenever VITE_USE_MOCKS=false; the mock (mockExistingCompanyFixture.ts) is entirely synthetic,
 * in-memory, and never touches a real or staging database. Keyed off useBusinessProfileSetupMocks rather
 * than useMocks directly — see that constant's doc comment in shared/env.ts for why this one feature
 * needs an independent override in Playwright. */
export const businessProfileSetupGateway: IBusinessProfileSetupGateway = useBusinessProfileSetupMocks
  ? mockBusinessProfileSetupGateway
  : httpBusinessProfileSetupGateway;

// Mock mode only: lets a browser test (Playwright) seed the synthetic Step 5 data set, mark locations as having assigned employees, or make the
// next assignment check fail. Never present when the real gateway is in use.
if (useBusinessProfileSetupMocks && typeof window !== 'undefined') {
  (window as unknown as { __epnMockBusinessProfile?: MockBusinessProfileSetupGatewayHooks }).__epnMockBusinessProfile = mockBusinessProfileSetupGateway;
}
